import React, { useState } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import client from '../api/client';
import './Login.css';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [devToken, setDevToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await client.post('/api/auth/request-password-reset', { email });
      setSubmitted(true);
      // Dev-only convenience: surface the token so admin can click the reset link locally.
      if (res.data?.devToken) setDevToken(res.data.devToken);
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo">VD</div>
          <h1>Forgot password</h1>
          <p>We'll send you a reset link.</p>
        </div>
        {!submitted ? (
          <form className="login-form" onSubmit={handleSubmit}>
            <label>Email
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            </label>
            <button type="submit">Send reset link</button>
          </form>
        ) : (
          <div>
            <p>If that account exists, we've sent a reset link.</p>
            {devToken && (
              <p style={{ fontSize: '0.85rem', background: '#f3f4f6', padding: '0.75rem', borderRadius: 6, wordBreak: 'break-all' }}>
                Dev link: <Link to={`/reset-password?token=${devToken}`}>{`/reset-password?token=${devToken.slice(0,10)}…`}</Link>
              </p>
            )}
          </div>
        )}
        <div className="login-links"><Link to="/login">Back to sign in</Link></div>
      </div>
    </div>
  );
}

export function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(location.search).get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setSubmitting(true);
    try {
      await client.post('/api/auth/reset-password', { token, newPassword: password });
      navigate('/login?reset=1', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo">VD</div>
          <h1>Set a new password</h1>
        </div>
        {error && <div className="login-error">{error}</div>}
        <form className="login-form" onSubmit={handleSubmit}>
          <label>New password
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="new-password" />
          </label>
          <label>Confirm password
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required autoComplete="new-password" />
          </label>
          <button type="submit" disabled={submitting}>{submitting ? 'Saving...' : 'Update password'}</button>
        </form>
        <div className="login-links"><Link to="/login">Back to sign in</Link></div>
      </div>
    </div>
  );
}
